import cloneDeep from "lodash.clonedeep";
import Axios from "../../axios";

export const enterFullscreen = () => {
    const elem = document.documentElement;
    if (elem.requestFullscreen) {
        elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen(); // Firefox
    } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen(); // Chrome, Safari, Opera
    } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen(); // IE/Edge
    }
};

export const exitFullscreen = () => {
    if (document.exitFullscreen) {
        document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen(); // Firefox
    } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen(); // Chrome, Safari, Opera
    } else if (document.msExitFullscreen) {
        document.msExitFullscreen(); // IE/Edge
    }
};

export const postDataForPreview = (state, flimpID, userID, sessionID) => {
    return new Promise((resolve, reject) => {
        let layout = cloneDeep(state.layout);
        let layoutList = cloneDeep(state.layoutList);

        layoutList = layoutList.map((item) => {
            return item[0] == state.layoutTitle
                ? [state.layoutTitle, layout]
                : item;
        });

        let payLoad = JSON.stringify({
            ...state.presentState,
            layoutList: layoutList,
        });

        let data = {
            fd: payLoad,
            f: flimpID,
            u: userID,
            sn: sessionID,
        };

        Axios.MicrositeService.POST_MICROSITE(data)
            .then((response) => {
                const { statusCode } = response.data;
                if (statusCode === "success") {
                    resolve({ success: true });
                    window.open(
                        `${import.meta.env.VITE_PREVIEW_URL}${
                            state.short_code
                        }`,
                        "_blank"
                    );
                } else if (statusCode === "401") {
                    window.location = `${location.protocol}//${location.hostname}/login`;
                    reject({ success: false, error: "Unauthorized" });
                } else {
                    reject({ success: false, error: "Save failed" });
                }
            })
            .catch((error) => {
                reject({ success: false, error });
            });
    });
};

export const saveTemplate = (state, userID, sessionID) => {
    return new Promise((resolve, reject) => {
        const blockHeight = JSON.stringify(state.blockHeight);
        let layout = cloneDeep(state.layout);

        let blockDataToPush = { ...state.presentState, layout: layout };

        const newLayout = JSON.stringify(blockDataToPush);

        let data = {
            u: userID,
            sn: sessionID,
            td: newLayout,
            t: "T",
            o: "1", // 2 for default 1 for custom
            h: blockHeight,
            d: "N", // Y for default N for custom
            c: "custom", // default_template & custom
        };

        if (data) {
            Axios.TemplateService.POST_TEMPLATE(data)
                .then((response) => {
                    if (response.status == "200") {
                        resolve({ success: true });
                    } else {
                        reject({ success: false, error: "Save failed" });
                    }
                })
                .catch((error) => {
                    reject({ success: false, error });
                });
        }
    });
};

export const postData = (presentState, flimpID, userID, sessionID) => {
    return new Promise((resolve, reject) => {
        let payload = JSON.stringify(presentState);

        let data = {
            fd: payload,
            f: flimpID,
            u: userID,
            sn: sessionID,
        };

        Axios.MicrositeService.POST_MICROSITE(data)
            .then((response) => {
                if (response.data.statusCode === "success") {
                    resolve({ success: true });
                }
                if (response.data.statusCode !== "success") {
                    reject({ success: false, error: "Save failed" });
                }
                if (response.data.statusCode == "401") {
                    window.location =
                        location.protocol + "//" + location.hostname + "/login";
                }
            })
            .catch((error) => {
                reject({ success: false, error });
            });
    });
};

export const createSnapshot = (
    portalHeight,
    portalWidth,
    flimpID,
    userID,
    sessionID
) => {
    const data = {
        u: userID,
        sn: sessionID,
        f: flimpID,
        w: portalWidth,
        h: portalHeight,
    };
    return Axios.AWSService.CREATE_SNAPSHOT(data)
};
